/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PleaseCallMeQueryVariables = {};
export type PleaseCallMeQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"PleaseCallMe_viewer">;
    };
};
export type PleaseCallMeQuery = {
    readonly response: PleaseCallMeQueryResponse;
    readonly variables: PleaseCallMeQueryVariables;
};



/*
query PleaseCallMeQuery {
  viewer {
    ...PleaseCallMe_viewer
  }
}

fragment PleaseCallMe_viewer on Viewer {
  pleaseCallMeConfig {
    name
    id
  }
}
*/

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PleaseCallMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PleaseCallMe_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PleaseCallMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PleaseCallMeConfig",
            "kind": "LinkedField",
            "name": "pleaseCallMeConfig",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0977f13230af9ac4959c9ada62f2f82e",
    "id": null,
    "metadata": {},
    "name": "PleaseCallMeQuery",
    "operationKind": "query",
    "text": "query PleaseCallMeQuery {\n  viewer {\n    ...PleaseCallMe_viewer\n  }\n}\n\nfragment PleaseCallMe_viewer on Viewer {\n  pleaseCallMeConfig {\n    name\n    id\n  }\n}\n"
  }
};
(node as any).hash = '5459a3dae67a28a7ef453545218fe929';
export default node;
